<div class="board">
  <div class="head">
    <div>
      <h2>Claim funnel</h2>
      <p class="sub">
        Every event an invitation was prepared for, and how far its organizer got.
        <!-- Stated because a reader will otherwise assume a click column exists
             and wonder why it is missing. -->
        The claim link opens the page directly, so a click and an open are the
        same event — there is no separate click stage to show.
        <!-- Said plainly, because the previous version of this page counted
             scanners as people and nobody could tell from looking at it. -->
        Opens and people count humans only; mail-security link checkers and our
        own tooling are counted separately under Automated.
      </p>
    </div>
    <button mat-stroked-button (click)="load()" [disabled]="loading">Refresh</button>
  </div>

  <div class="stats" *ngIf="!loading && !error">
    <div class="stat"><div class="n">{{ invited }}</div><div class="l">Invited</div></div>
    <div class="stat">
      <div class="n">{{ openedCount }}</div>
      <div class="l">Opened<app-info-hint label="Opened"
        text="Events a person opened at least once. Mail-security link checkers and our own tooling are not counted here — they are under Machines only."
      ></app-info-hint></div>
    </div>
    <div class="stat quiet" *ngIf="machineOnlyCount">
      <div class="n">{{ machineOnlyCount }}</div>
      <div class="l">Machines only<app-info-hint label="Machines only"
        text="Invitations nothing but a scanner ever opened. It proves the mail reached a working inbox, but no person has looked yet."
      ></app-info-hint></div>
    </div>
    <div class="stat">
      <div class="n">{{ submittedCount }}</div>
      <div class="l">Started<app-info-hint label="Started"
        text="Organizers who submitted step 1 of the wizard but never finished claiming. Submitted-but-not-claimed is the group worth chasing."
      ></app-info-hint></div>
    </div>
    <div class="stat"><div class="n">{{ claimedCount }}</div><div class="l">Claimed</div></div>
  </div>

  <div class="notice ok" *ngIf="notice">{{ notice }}</div>
  <div class="notice bad" *ngIf="error">{{ error }}</div>

  <div class="loading" *ngIf="loading"><mat-spinner diameter="28"></mat-spinner></div>

  <table *ngIf="!loading && rows.length">
    <thead>
      <tr>
        <th>Event</th>
        <th>Invited contact<app-info-hint label="Invited contact"
          text="The person the invitation was addressed to, from the campaign list. Not necessarily whoever ended up claiming the space."
        ></app-info-hint></th>
        <th>Claimed by<app-info-hint label="Claimed by"
          text="The account that actually holds the space now. It differs from the invited contact whenever an invitation was forwarded to a colleague."
        ></app-info-hint></th>
        <th>Invited<app-info-hint label="Invited"
          text="When the invitation was emailed. The board is ordered newest first, so the batch you sent most recently is at the top; spaces prepared but never emailed sit at the bottom."
        ></app-info-hint></th>
        <th>Delivery<app-info-hint label="Delivery"
          text="What Resend last saw happen to the invitation itself. Bounced or marked as spam is the only part of this column you can fully trust: an open is a tracking pixel that image proxies fetch too, and a click can be a link checker following the tracked URL. Treat People as the confirmed number."
        ></app-info-hint></th>
        <th>Stage</th>
        <th class="num">Opens<app-info-hint label="Opens"
          text="Every open by a person, repeat visits included — one organizer coming back to the link four times counts as four."
        ></app-info-hint></th>
        <th class="num">People<app-info-hint label="People"
          text="Roughly how many different people opened it. Recognised by an id the claim page stores, falling back to address plus browser, so it errs towards counting one person twice rather than merging two into one."
        ></app-info-hint></th>
        <th class="num">Automated<app-info-hint label="Automated"
          text="Opens by mail-security link checkers and our own tooling. Shown rather than hidden: on a row with no human opens, this is the only evidence the invitation was delivered at all."
        ></app-info-hint></th>
        <th>Last opened</th><th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let r of rows" [class.claimed]="r.ownerId">
        <td>
          <!-- The name goes to the space on the admin side; the wizard the
               organizer sees hangs off the line below, in a new tab so the
               funnel keeps its place. -->
          <div class="title">
            <app-event-link [eventId]="r.eventId" [title]="r.title"></app-event-link>
          </div>
          <div class="meta">
            <a
              [routerLink]="['/spaceClaim']"
              [queryParams]="{ eventID: r.eventId }"
              target="_blank"
              rel="noopener"
              [title]="'Open the claim page for ' + r.title"
              >claim page ↗</a
            >
            · {{ r.eventId }}
          </div>
        </td>
        <td>
          <div>{{ r.contactName || '—' }}</div>
          <div class="meta">{{ r.contactEmail || '—' }}</div>
        </td>
        <!-- Who to approach about a space that is already taken. The invited
             contact is who we wrote to; this is who answered. -->
        <td>
          <ng-container *ngIf="r.ownerId; else unclaimedOwner">
            <div>
              <app-person-link
                [uid]="r.ownerId"
                [name]="r.ownerName || 'Unknown account'"
                (failed)="error = $event"
              ></app-person-link>
            </div>
            <div class="meta">
              <a *ngIf="r.ownerEmail" [href]="'mailto:' + r.ownerEmail">{{ r.ownerEmail }}</a>
              <!-- An owner the users table has no row for: show the uid, so a
                   claim by a deleted or unsynced account is still traceable. -->
              <span *ngIf="!r.ownerEmail">{{ r.ownerId }}</span>
            </div>
          </ng-container>
          <ng-template #unclaimedOwner><span class="meta">—</span></ng-template>
        </td>
        <td>
          <ng-container *ngIf="r.sentAt; else neverSent">
            <div>{{ r.sentAt | date: 'd MMM' }}</div>
            <div class="meta">{{ r.sentAt | date: 'HH:mm' }} · {{ daysSinceSent(r) }}</div>
          </ng-container>
          <ng-template #neverSent><span class="meta">not sent</span></ng-template>
        </td>
        <td>
          <span class="pill" *ngIf="r.delivery" [attr.data-delivery]="deliveryTone(r)"
                [title]="deliveryTitle(r)">{{ r.delivery }}</span>
          <span class="meta" *ngIf="!r.delivery">{{ r.sentAt ? 'not checked' : '—' }}</span>
        </td>
        <td><span class="pill" [attr.data-stage]="stage(r)">{{ stageLabel(r) }}</span></td>
        <td class="num">{{ r.opened || '—' }}</td>
        <td class="num">{{ r.people || '—' }}</td>
        <!-- Dimmed, not hidden: on a row with no human opens this is the only
             evidence the invitation reached a working inbox at all. -->
        <td class="num quiet"
            [title]="r.automatedVisitors + ' link checkers or tools, ' + r.automatedOpens + ' opens'">
          {{ r.automatedOpens || '—' }}
        </td>
        <td class="meta">{{ r.lastOpenedAt ? (r.lastOpenedAt | date: 'd MMM, HH:mm') : '—' }}</td>
        <td class="actions">
          <!-- One confirmation at a time, so the two destructive actions can
               never both be mid-question on the same row. -->
          <ng-container *ngIf="isPending(r, 'unclaim')">
            <span class="confirm">Release it?</span>
            <button mat-flat-button color="warn" [disabled]="busyId === r.eventId"
                    (click)="confirmUnclaim(r)">Yes, unclaim</button>
            <button mat-button (click)="cancel()">Cancel</button>
          </ng-container>

          <ng-container *ngIf="isPending(r, 'clear')">
            <span class="confirm">Wipe the counters?</span>
            <button mat-flat-button color="warn" [disabled]="busyId === r.eventId"
                    (click)="confirmClear(r)">Yes, clear</button>
            <button mat-button (click)="cancel()">Cancel</button>
          </ng-container>

          <ng-container *ngIf="!isPending(r, 'unclaim') && !isPending(r, 'clear')">
            <button *ngIf="r.ownerId" mat-stroked-button color="warn"
                    (click)="ask(r, 'unclaim')">Unclaim</button>
            <!-- Offered only where something was measured: a row nobody has
                 opened has nothing to reset. -->
            <button *ngIf="hasStats(r)" mat-button class="clear"
                    (click)="ask(r, 'clear')"
                    title="Set this event's opens, people and started back to zero">
              Clear stats
            </button>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>

  <p class="empty" *ngIf="!loading && !rows.length && !error">
    No events carry a claim link yet.
  </p>
</div>
